export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line' },
];

export const videos = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20giant%20planetary%20engines%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20gold%20tones%2C%20movie%20poster%20style%20with%20Chinese%20text%20space%2C%20epic%20scale%2C%20clean%20background&width=800&height=450&seq=video-cover-01&orientation=landscape',
    rating: 9.2,
    year: 2025,
    region: '中国大陆',
    type: '科幻 / 冒险',
    description: '人类在宇宙中面临前所未有的危机，为了寻找新的家园，地球联合政府启动了史无前例的星际迁移计划。年轻一代的宇航员们肩负着全人类的希望，踏上了充满未知与危险的星际旅程。',
    updateInfo: '更新至HD',
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '狂飙',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20intense%20police%20drama%2C%20noir%20atmosphere%2C%20dark%20and%20moody%20cinematic%20lighting%2C%20two%20men%20facing%20off%2C%20urban%20night%20scene%2C%20film%20poster%20style%20with%20warm%20accents&width=800&height=450&seq=video-cover-02&orientation=landscape',
    rating: 9.5,
    year: 2023,
    region: '中国大陆',
    type: '剧情 / 犯罪',
    description: '一部横跨二十年的扫黑除恶题材剧集，讲述了警察安欣与黑恶势力高启强之间长达二十年的正邪较量，展现了当代中国扫黑除恶的艰难历程与坚定决心。',
    updateInfo: '全39集',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '繁花',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20drama%20poster%2C%20elegant%20vintage%20aesthetic%2C%20warm%20golden%20lighting%2C%20retro%20Shanghai%20street%20scene%2C%20fashionable%20characters%2C%20cinematic%20composition%2C%20film%20poster%20style%2C%20rich%20amber%20and%20gold%20tones&width=800&height=450&seq=video-cover-03&orientation=landscape',
    rating: 9.3,
    year: 2023,
    region: '中国大陆',
    type: '剧情 / 爱情',
    description: '九十年代的上海，阿宝凭借自己的智慧和魄力，在改革开放的大潮中脱颖而出，成为了上海滩的风云人物。在商海与情场之间，他经历了人生的起起落落。',
    updateInfo: '全30集',
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '长津湖之水门桥',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%2C%20soldiers%20in%20winter%20battle%2C%20snowy%20mountain%20landscape%2C%20dramatic%20cinematic%20lighting%2C%20heroic%20composition%2C%20film%20poster%20style%2C%20cold%20blue%20and%20warm%20orange%20contrast&width=800&height=450&seq=video-cover-04&orientation=landscape',
    rating: 9.0,
    year: 2022,
    region: '中国大陆',
    type: '战争 / 历史',
    description: '抗美援朝战争中，志愿军七连战士们在长津湖战役后，接受了更加艰巨的任务——炸毁水门桥，切断美军撤退路线。在极寒天气和敌人猛烈火力下，他们用生命诠释了什么是中国军人的钢铁意志。',
    updateInfo: '更新至HD',
    isHot: false,
    isNew: false,
  },
  {
    id: 5,
    title: '三体',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20with%20cosmic%20background%2C%20mysterious%20three-body%20problem%20visualization%2C%20dark%20space%20with%20stars%2C%20futuristic%20technology%2C%20cinematic%20composition%2C%20film%20poster%20style%2C%20deep%20space%20colors&width=800&height=450&seq=video-cover-05&orientation=landscape',
    rating: 8.8,
    year: 2023,
    region: '中国大陆',
    type: '科幻 / 悬疑',
    description: '根据刘慈欣同名科幻小说改编，讲述了地球人类文明和三体文明的信息交流、生死搏杀以及两个文明在宇宙中的兴衰历程。一场跨越光年的文明博弈即将展开。',
    updateInfo: '全30集',
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '你好，李焕英',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%2C%201980s%20retro%20China%20setting%2C%20mother%20and%20daughter%20warm%20moment%2C%20nostalgic%20aesthetic%2C%20bright%20warm%20lighting%2C%20film%20poster%20style%2C%20soft%20golden%20tones&width=800&height=450&seq=video-cover-06&orientation=landscape',
    rating: 9.1,
    year: 2021,
    region: '中国大陆',
    type: '喜剧 / 剧情',
    description: '2001年的某一天，刚考上大学的贾晓玲遭遇了人生中的一次大起大落。一心想要成为母亲骄傲的她，意外穿越到了1981年，与年轻时的母亲李焕英相遇，开启了一段充满欢笑与泪水的奇妙旅程。',
    updateInfo: '更新至HD',
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '乘风破浪的姐姐 第四季',
    category: 'zongyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20female%20celebrities%20on%20stage%2C%20glamorous%20performance%2C%20colorful%20stage%20lighting%2C%20energetic%20atmosphere%2C%20show%20poster%20style%2C%20vibrant%20warm%20colors&width=800&height=450&seq=video-cover-07&orientation=landscape',
    rating: 8.5,
    year: 2024,
    region: '中国大陆',
    type: '音乐 / 真人秀',
    description: '30位30+的姐姐们再次集结，通过唱跳竞演展现成熟女性的魅力与实力。她们用舞台证明，年龄从来不是限制，每个阶段的女性都可以闪闪发光。',
    updateInfo: '更新至第8期',
    isHot: true,
    isNew: true,
  },
  {
    id: 8,
    title: '斗破苍穹 年番',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%2C%20fantasy%20martial%20arts%20hero%20with%20flame%20powers%2C%20ancient%20Chinese%20fantasy%20setting%2C%20dynamic%20action%20pose%2C%20anime%20poster%20style%2C%20warm%20fire%20and%20gold%20tones&width=800&height=450&seq=video-cover-08&orientation=landscape',
    rating: 8.7,
    year: 2024,
    region: '中国大陆',
    type: '玄幻 / 热血',
    description: '少年萧炎在斗气大陆上历经磨难，凭借坚韧不拔的意志和强大的天赋，一步步走向巅峰。最新的年番篇章，萧炎将踏入更加广阔的天地，迎接全新的挑战。',
    updateInfo: '更新至第52话',
    isHot: true,
    isNew: false,
  },
  {
    id: 9,
    title: '满江红',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20poster%2C%20ancient%20Chinese%20courtyard%20setting%2C%20dramatic%20shadow%20and%20light%2C%20mysterious%20atmosphere%2C%20film%20poster%20style%2C%20dark%20red%20and%20gold%20tones&width=800&height=450&seq=video-cover-09&orientation=landscape',
    rating: 8.9,
    year: 2023,
    region: '中国大陆',
    type: '悬疑 / 历史',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    updateInfo: '更新至HD',
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '奔跑吧 第十二季',
    category: 'zongyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%2C%20celebrities%20running%20and%20laughing%2C%20bright%20sunny%20outdoor%20setting%2C%20fun%20and%20energetic%2C%20show%20poster%20style%2C%20vibrant%20warm%20colors&width=800&height=450&seq=video-cover-10&orientation=landscape',
    rating: 8.3,
    year: 2024,
    region: '中国大陆',
    type: '真人秀 / 竞技',
    description: '新一季的奔跑吧家族再次集结，全新阵容带来更多惊喜和欢乐。在各地的精彩冒险中，成员们将完成各种趣味挑战，为观众带来无尽的欢笑。',
    updateInfo: '更新至第6期',
    isHot: true,
    isNew: true,
  },
  {
    id: 11,
    title: '完美世界 年番',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20young%20warrior%20in%20ancient%20fantasy%20world%2C%20epic%20battle%20scene%2C%20mythical%20creatures%2C%20anime%20style%2C%20warm%20golden%20and%20jade%20green%20tones&width=800&height=450&seq=video-cover-11&orientation=landscape',
    rating: 9.0,
    year: 2024,
    region: '中国大陆',
    type: '玄幻 / 热血',
    description: '石昊在完美世界中不断成长，从一个顽皮少年蜕变为睥睨天下的荒天帝。年番篇章继续讲述他在上界的传奇冒险，与各方势力斗智斗勇的精彩故事。',
    updateInfo: '更新至第108话',
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: '舌尖上的中国 第四季',
    category: 'jilupian',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20beautiful%20Chinese%20cuisine%20close-up%2C%20steaming%20hot%20dishes%2C%20traditional%20cooking%2C%20warm%20kitchen%20lighting%2C%20documentary%20poster%20style%2C%20rich%20food%20colors&width=800&height=450&seq=video-cover-12&orientation=landscape',
    rating: 9.4,
    year: 2024,
    region: '中国大陆',
    type: '美食 / 人文',
    description: '新一季的舌尖上的中国将镜头对准了中国各地更加细微的美食文化，从街头小吃到家常味道，从传统工艺到创新料理，用美食讲述中国人的生活故事和情感记忆。',
    updateInfo: '更新至第4集',
    isHot: false,
    isNew: true,
  },
  {
    id: 13,
    title: '封神第一部：朝歌风云',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20film%20poster%2C%20ancient%20Chinese%20fantasy%20warriors%2C%20mythical%20beasts%2C%20dramatic%20cinematic%20lighting%2C%20film%20poster%20style%2C%20bronze%20and%20gold%20tones&width=800&height=450&seq=video-cover-13&orientation=landscape',
    rating: 8.6,
    year: 2023,
    region: '中国大陆',
    type: '奇幻 / 史诗',
    description: '商王殷寿暴虐无道，昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现了殷寿的真面目，反出朝歌，开启了一段波澜壮阔的封神传奇。',
    updateInfo: '更新至HD',
    isHot: false,
    isNew: false,
  },
  {
    id: 14,
    title: '庆余年 第二季',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20ancient%20Chinese%20palace%20setting%2C%20handsome%20male%20lead%2C%20intrigue%20and%20suspense%2C%20film%20poster%20style%2C%20dark%20red%20and%20gold%20royal%20tones&width=800&height=450&seq=video-cover-14&orientation=landscape',
    rating: 9.0,
    year: 2024,
    region: '中国大陆',
    type: '古装 / 权谋',
    description: '范闲在经历了第一季的生死考验后，以更加成熟的面貌回归。庆国的朝堂之上暗流涌动，各方势力虎视眈眈，范闲将如何运用智慧与勇气，在权力的游戏中开辟自己的道路。',
    updateInfo: '更新至第36集',
    isHot: true,
    isNew: true,
  },
  {
    id: 15,
    title: '鬼灭之刃 柱训练篇',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%2C%20demon%20slayer%20warriors%20training%2C%20dynamic%20action%20scene%2C%20traditional%20Japanese%20aesthetic%2C%20vibrant%20colors%2C%20anime%20key%20visual%20style%2C%20warm%20and%20cool%20tone%20contrast&width=800&height=450&seq=video-cover-15&orientation=landscape',
    rating: 9.1,
    year: 2024,
    region: '日本',
    type: '热血 / 战斗',
    description: '炭治郎与伙伴们在结束了刀匠村篇的战斗后，来到了鬼杀队的柱面前，接受各位柱的严酷训练。在训练中，他们不断提升实力，为最终决战做着最后的准备。',
    updateInfo: '更新至第8话',
    isHot: true,
    isNew: true,
  },
  {
    id: 16,
    title: '航拍中国 第四季',
    category: 'jilupian',
    cover: 'https://readdy.ai/api/search-image?query=Aerial%20photography%20of%20China%20documentary%20poster%2C%20stunning%20drone%20shots%20of%20Chinese%20landscapes%2C%20mountains%20rivers%20and%20cities%2C%20documentary%20poster%20style%2C%20breathtaking%20natural%20colors&width=800&height=450&seq=video-cover-16&orientation=landscape',
    rating: 9.3,
    year: 2024,
    region: '中国大陆',
    type: '自然 / 人文',
    description: '以空中视角俯瞰中国，立体化展示中国历史人文、地理风貌及社会形态。新一季继续带观众飞越神州大地，感受中国各地的壮美风光与人文底蕴。',
    updateInfo: '更新至第6集',
    isHot: false,
    isNew: true,
  },
  {
    id: 17,
    title: '热辣滚烫',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%2C%20fitness%20and%20boxing%20theme%2C%20female%20lead%20transformation%2C%20inspirational%20atmosphere%2C%20warm%20lighting%2C%20film%20poster%20style%2C%20energetic%20red%20and%20warm%20tones&width=800&height=450&seq=video-cover-17&orientation=landscape',
    rating: 8.8,
    year: 2024,
    region: '中国大陆',
    type: '喜剧 / 励志',
    description: '乐莹是一个善良的女孩，但生活却给了她重重一击。在经历了一系列挫折后，她决定通过拳击改变自己，开启一段热辣滚烫的逆袭人生。',
    updateInfo: '更新至HD',
    isHot: false,
    isNew: false,
  },
  {
    id: 18,
    title: '歌手2024',
    category: 'zongyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%2C%20singer%20on%20grand%20stage%2C%20dramatic%20spotlight%2C%20musical%20atmosphere%2C%20show%20poster%20style%2C%20vibrant%20stage%20lighting&width=800&height=450&seq=video-cover-18&orientation=landscape',
    rating: 8.6,
    year: 2024,
    region: '中国大陆',
    type: '音乐 / 竞演',
    description: '顶级歌手汇聚一堂，用最真实的声音进行巅峰对决。无修音、全开麦的严苛赛制下，每位歌手都将展现出最真实的演唱实力，为观众带来一场场震撼心灵的视听盛宴。',
    updateInfo: '更新至第12期',
    isHot: true,
    isNew: false,
  },
  {
    id: 19,
    title: '蓝色星球 第三季',
    category: 'jilupian',
    cover: 'https://readdy.ai/api/search-image?query=Ocean%20nature%20documentary%20poster%2C%20underwater%20marine%20life%2C%20colorful%20coral%20reef%2C%20whales%20and%20dolphins%2C%20documentary%20poster%20style%2C%20deep%20blue%20and%20vibrant%20marine%20colors&width=800&height=450&seq=video-cover-19&orientation=landscape',
    rating: 9.6,
    year: 2024,
    region: '英国',
    type: '自然 / 探索',
    description: 'BBC倾力打造的海洋纪录片系列全新回归，采用最新的水下拍摄技术，带领观众深入海洋世界，探索前所未见的海洋生物与壮丽的海底奇观。',
    updateInfo: '更新至第6集',
    isHot: false,
    isNew: true,
  },
  {
    id: 20,
    title: '仙逆 年番',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20donghua%20anime%20poster%2C%20immortal%20warrior%20flying%20in%20clouds%2C%20ancient%20Chinese%20fantasy%20world%2C%20mystical%20atmosphere%2C%20anime%20style%2C%20ethereal%20jade%20and%20gold%20tones&width=800&height=450&seq=video-cover-20&orientation=landscape',
    rating: 8.9,
    year: 2024,
    region: '中国大陆',
    type: '仙侠 / 热血',
    description: '少年王林逆天改命，以凡人之躯踏上修仙之路。在弱肉强食的修真世界中，他凭借坚韧不拔的意志和过人的智慧，一步步突破境界，书写属于自己的传奇。',
    updateInfo: '更新至第64话',
    isHot: true,
    isNew: false,
  },
];